<template>
  <div class="farm-list">
    <!-- <aside>
      <div class="search">
          <div class="icon h-i-center">
            <i class="material-icons">
              {{$ml.get(`Search`)}}
            </i>
          </div>
          <input class="h-empty-input" type="text" placeholder="Search" v-model="searchQuery">
      </div>
      <nav>
        <ul class="farms">
          <li
            class="farm"
            v-for="farm in filteredUserFarms"
            :key="farm.id"
            :ref="`farm-${farm.id}`"
            @click="expandFields($event,farm.id)"
            :class="{ is_active : (farm.id == $route.params.farmId) }"
          >
            <router-link :to="`/dashboard/farms/list-view/${farm.id}`" draggable="false">
              <span>{{farm.name}}</span>
              <span class="info">{{farm.fields.length}} {{$ml.get(`fields`)}}</span>
            </router-link>
            <ul class="fields">
              <li
                class="field"
                v-for="field in farm.fields"
                :key="field.id"
                :ref="`field-${field.id}`"
                @click="selectField($event,field.id)"
                :class="{ is_active : field.id == $route.params.fieldId }"
              >
                <router-link :to="`/dashboard/farms/list-view/${farm.id}/${field.id}`" draggable="false">
                  <span>{{field.name}}</span>
                  <span class="info">{{field.area}} {{$ml.get(`hectares`)}}</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </aside> -->

    <!-- <router-view :allFarms="allUserFarms" :allFields="allUserFields"></router-view> -->

    <MobileSidebarWrapper :params="['farmId', 'fieldId']">
      <template slot="sidebar">
        <aside>
          <div class="search">
              <div class="icon h-i-center">
                <i class="material-icons">
                  search
                </i>
              </div>
              <input class="h-empty-input" type="text" :placeholder="$ml.get(`Search`)" v-model="searchQuery">
          </div>
          <nav>
            <ul class="farms">
              <li
                class="farm"
                v-for="farm in filteredUserFarms"
                :key="farm.id"
                :ref="`farm-${farm.id}`"
                @click="expandFields($event,farm.id)"
                :class="{ is_active : (farm.id == $route.params.farmId) }"

              >
                <router-link :to="`/dashboard/farms/list-view/${farm.id}`" draggable="false">
                  <span>{{farm.name}}</span>
                  <span class="info">{{farm.fields.length}} {{$ml.get(`fields`)}}</span>
                </router-link>
                <ul class="fields">
                  <li
                    class="field"
                    v-for="field in farm.fields"
                    :key="field.id"
                    :ref="`field-${field.id}`"
                    @click="selectField($event,field.id)"
                    :class="{ is_active : field.id == $route.params.fieldId }"
                  >
                    <router-link :to="`/dashboard/farms/list-view/${farm.id}/${field.id}`" draggable="false">
                      <span>{{field.name}}</span>
                      <!-- <span class="info">{{field.area}} {{$ml.get(`hectares`)}}</span> -->
                      <span class="info">
                        {{ $store.getters['unit/convert']('ha', field.area) }} 
                        {{ $store.getters['unit/getLabel']('ha') }}
                      </span>
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </aside>
      </template>
      <template slot="content">
        <router-view :allFarms="farms" :allFields="fields"></router-view>
      </template>
    </MobileSidebarWrapper>

  </div>
</template>

<script>
import MobileSidebarWrapper from '@/components/common/mobile-sidebar-wrapper/MobileSidebarWrapper'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      searchQuery : null,
    }
  },
  components: {
    MobileSidebarWrapper
  },
  computed : {
    ...mapGetters({
      farms: 'farms/data',
      fields: 'farms/fields',
    }),
    filteredUserFarms() {
      return this.searchQuery ? this.farms.filter(farm => farm.name.toLowerCase().includes(this.searchQuery.toLowerCase())) : this.farms;
    }
  },
  methods : {
    expandFields(e,i) {
      let farms = document.querySelectorAll('ul.farms li.farm');
      farms.forEach( (el) =>  {
        el.classList.remove('is_active');
      } );
      this.$refs[`farm-${i}`][0].classList.add('is_active')
    },
    selectField(e,i) {
      let fields = document.querySelectorAll('li.field');
      fields.forEach( (el) => {
        el.classList.remove('is_active');
      } );
        this.$refs[`field-${i}`][0].classList.add('is_active')
    },
  },
}
</script>

<style lang="scss" scoped>
.farm-list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  aside {
    min-width: 320px;
    nav {
      ul.farms {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        li.farm {
          list-style-type: none;
          border-bottom: 1px solid #E0E0E0;
          display: flex;
          flex-direction: column;
          padding-bottom: 4px;
          margin-bottom: 4px;
          &.is_active {
            > a {
              background-color: $mainGreen;
              color: #fff;
              // border-bottom-right-radius: 0;
              // border-bottom-left-radius: 0;
            }
            ul.fields {
              height: auto;
            }
          }
          &:first-child {
            border-top: 1px solid #E0E0E0;
          }
          a {
            width: 100%;
            padding: 16px;
            color: #4C5056;
            font-size: 16px;
            font-weight: 500;
            border-radius: 5px;
            overflow: hidden;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            transition: .3s;
            span {
              pointer-events: none;
              &.info {
                font-size: 12px;
                text-transform: uppercase;
                white-space: nowrap;
                padding-left: 4px;
              }
            }
          }
          ul.fields {
            background-color: #F3F3F3;
            padding: 0;
            margin: 0 4px;
            display: flex;
            flex-direction: column;
            height:0;
            overflow: hidden;
            transition: .3s;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            li.field {
              border-bottom: 1px solid #E0E0E0;
              list-style-type: none;
              display: flex;
              margin-top: 2px;
              padding-top: 2px;
              &:last-child {
                border-bottom-width: 0;
              }
              &.is_active {
                a {
                  color: #fff;
                  background-color: $mainGreen;
                }
              }
            }
          }
        }
      }
    }
  }

}
</style>
